import React from 'react';
import './SectionSource.css';

// Tiny per-section source attribution. Lives directly under the section
// it cites so the user sees the provenance in context, not buried in a
// page-level footer.
//
// Usage:
//   <SectionSource>
//     Source: Central Bank of Cyprus — Residential Property Price Indices,
//     2026 Q1 release.
//   </SectionSource>
export default function SectionSource({ children, dark = false, className = '' }) {
  return (
    <p className={`nd-section-source ${dark ? 'nd-section-source--dark' : ''} ${className}`}>
      {children}
    </p>
  );
}
